<template>
    <div>
        <div id="app">
            <!-- 手机 -->
            <el-table :header-cell-style="{background:'#4B78FF',color:'#FFFFFF'}" border style="width: 100%" v-loading="tableloading" :data="customerList" v-if="$store.getters.ismobilePhone" @row-click="selDetails">
                <el-table-column prop="code" label="客戶編號" ></el-table-column>
                <el-table-column prop="name" label="姓名" width="190px" > </el-table-column>
                <!--<el-table-column prop="id" label="操作" fixed="right" width="100" >-->
                    <!--<template slot-scope="scope">-->
                            <!--<el-button  type="primary" @click.native="selDetails(scope.row.id)"  ><i class="fa fa-search-plus"/> 详情</el-button>-->
                            <!--&lt;!&ndash;<el-button v-if="scope.row.dist == 2"  type="primary" @click.native="selSotrIn(scope.row.id)"  ><i class="fa fa-search-plus"/> 详情</el-button>&ndash;&gt;-->
                            <!--&lt;!&ndash;<el-button v-if="scope.row.dist == 3"  type="primary" @click.native="selSotrOn(scope.row.id)"  ><i class="fa fa-search-plus"/> 详情</el-button>&ndash;&gt;-->
                    <!--</template>-->
                <!--</el-table-column>-->
            </el-table>

            <!-- 电脑 -->
            <el-table :header-cell-style="{background:'#4B78FF',color:'#FFFFFF'}" style="width: 100%" v-loading="tableloading" :data="customerList" v-else>
                <el-table-column prop="name" label="姓名" width="200"></el-table-column>
                <el-table-column prop="phone" label="電話" width="200"></el-table-column>
                <el-table-column prop="sales" label="銷售員" width="200"></el-table-column>
                <el-table-column prop="address" label="地址"></el-table-column>
                <el-table-column prop="createDate" label="創建時間">
                    <template slot-scope="scope">
                        <span>{{scope.row.createDate*1000 | date('%Y-%m-%d %H:%M')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="操作" fixed="right" width="100" >
                    <template slot-scope="scope">
                        <el-button  type="primary" @click.native="selDetails(scope.row)"  ><i class="fa fa-search-plus"/> 详情</el-button>
                        <!--<el-button v-if="scope.row.dist == 2"  type="primary" @click.native="selSotrIn(scope.row.id)"  ><i class="fa fa-search-plus"/> 详情</el-button>-->
                        <!--<el-button v-if="scope.row.dist == 3"  type="primary" @click.native="selSotrOn(scope.row.id)"  ><i class="fa fa-search-plus"/> 详情</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--分页-->
        <div class="pagination">
            <el-pagination
                    layout="total, prev, pager, next"
                    @current-change="handleCurrentChange"
                    :current-page.sync="pager.page"
                    :page-size="pager.size"
                    :total="pager.total">
            </el-pagination>
        </div>


        <!--&lt;!&ndash;編輯頁面&ndash;&gt;-->
        <el-dialog :title="dialogName" :visible.sync="dialogDiscEditVisible" width="400px">
            <el-form  :model="customerForm"  :rules="customerRules" ref="customerForm" label-width="130px" size="small">
                <el-row :gutter="0">
                    <el-col :span="24">
                        <el-form-item label="客戶編號:" prop="code">
                            <el-input v-model="customerForm.code" type="text" style="width:200px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="姓名:" prop="name">
                            <el-input v-model="customerForm.name"  placeholder="" auto-complete="off" style="width:200px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="電話:" prop="phone">
                            <el-input v-model="customerForm.phone"  placeholder="" auto-complete="off" style="width:200px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="地址:" prop="address">
                            <el-input v-model="customerForm.address"  placeholder="" auto-complete="off" style="width:200px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-col :span="24">
                    <el-form-item label="銷售員:" prop="sales">
                        <el-input v-model="customerForm.sales"  placeholder="" auto-complete="off" style="width:200px"></el-input>
                    </el-form-item>
                </el-col>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogDiscEditVisible = false">取消</el-button>
                <el-button type="primary"  @click="customerSave" :loading="addEidtloading">確認</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { getCustomerList,insertCustomer,getValidateCustomerCode,getSearchList} from '../api/api'

    export default {
        inject: ['reload'],
        methods: {
            getSearchList(){
                this.tableloading=true;
                var keywords = this.$store.getters.keywords;
                if(keywords == '' || keywords == null){
                    keywords = "";
                }
                var params={page:this.pager.page,size:this.pager.size,scode:keywords};
                return getSearchList(params).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode==200){
                        this.customerList=res.data.data;
                        this.pager.total=res.data.total;
                        this.pager.page=res.data.page;
                        this.pager.size=res.data.size;
                        this.tableloading=false;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            selDetails(row){   //查看客戶詳情資訊
                this.$store.commit("setSearchSte",true);
                this.$router.push({
                    name: '客戶詳情',
                    params: {
                        id: row.id
                    }
                })
            },
            selSotrIn(id){   //查看入倉詳情資訊
                this.$store.commit("setSearchSte",true);
                this.$store.commit("setWarehouseSta",true);
                this.$router.push({
                    name: '入倉',
                    params: {
                        id: id,
                        typeId:2
                    }
                })
            },
            selSotrOn(id){   //查看出倉詳情資訊
                this.$store.commit("setSearchSte",true);
                this.$store.commit("setStoronSta",true);
                this.$router.push({
                    name: '出倉',
                    params: {
                        id: id,
                        typeId:2
                    }
                })
            },



            handleCurrentChange(val){
                this.getSearchList();
            },
            handleSelectionChange(val){
                this.selectionItems=val;
            },
            customerAdd(index,row){
                this.dialogName="新增客戶資訊",
                    this.dialogDiscEditVisible=true;
                this.resetForm("customerForm");
            },
            customerSave(){
                this.$refs.customerForm.validate((valid) => {
                    if (valid) {
                        if(this.customerForm.id==""){       //新增
                            this.addEidtloading=true;
                            //var  params=Object.assign({},this.customerForm);
                            var  params={code:this.customerForm.code,name:this.customerForm.name,phone:this.customerForm.phone,address:this.customerForm.address,sales:this.customerForm.sales};
                            insertCustomer(params).then(data=>{
                                this.addEidtloading=false;
                                //let {errcode,errmsg}=data;
                                let {data:res={}}=data;
                                if(res.errcode==200){
                                    this.$message.success("新增成功！！");
                                    this.getCustomerList();
                                    this.resetForm("customerForm");
                                    this.dialogDiscEditVisible=false;
                                }else{
                                    this.$message.error(res.errmsg);
                                }
                            },err=>{
                                this.addEidtloading=false;
                            });
                        }else{                          //編輯
                            var  params=Object.assign({},this.bankForm);
                            updateBank(params).then(data=>{
                                this.addEidtloading=false;
                                let {errcode,errmsg}=data;
                                if(errcode==200){
                                    this.$message.success(this.$t('m.amendSuccess'));
                                    this.getCustomerList();
//                                    this.resetForm("bankForm");
                                    this.dialogDiscEditVisible=false;
                                }else{
                                    this.$message.error(data.errmsg);
                                }
                            },err=>{
                                this.addEidtloading=false;
                            });
                        }
                    }
                });
            },

            //清除表單內容
            resetForm(formName){
                if (this.$refs[formName]!==undefined) {
                    this.$refs[formName].resetFields();
                }
            }
        },
        data() {
            var validateNumber=(rule, value, callback) => {
                var reg=/^[1-15]\d*$/;
                if (value!=""&&value!=null){
                    if(!reg.test(value)){
                        callback(new Error(this.$t('m.canOnlyEnterPositiveNumber')));
                    }
                }
                callback();
            };

            //驗證客戶編號是否重複
            var validateCustomerCode=(rule, value, callback) => {
                var params={code:this.customerForm.code};
                return getValidateCustomerCode(params).then(data=>{
                    let item=data.data.data;
                    if(item){
                        callback(new Error('客戶編號重複！'));
                    }else {
                        callback();
                    }
                });
                callback();
            };
            return {
                //查詢準則

                searchBankName:"",
                customerList:[],
                selectionItems:[],
                tableloading:false,
                addEidtloading:false,
                dialogDiscEditVisible:false,
                pager:{
                    page:0,
                    size:10,
                    total:0
                },
                dialogName:'',
                customerForm:{
                    id:"",
                    sales:"",
                    code:"",
                    name:"",
                    phone:"",
                    address:''
                },
                //新增客戶資訊表單驗證
                customerRules: {
                    code: [
                        {required: true, message: '請輸入客戶編號', trigger: 'blur' },
                        { validator: validateCustomerCode,trigger: 'blur' }
                    ],
                    name:[
                        {required: true, message: '請輸入客戶名', trigger: 'blur' }
                    ],
                    phone:[
                        {required: true, message: '請輸入手機號', trigger: 'blur' }
                    ],
                    address:[
                        {required: true, message: '請輸入位址', trigger: 'blur' }
                    ],
                    sales:[
                        {required: true, message: '請輸入銷售員', trigger: 'blur' }
                    ]
                }
            }
        },

//        mounted() {
//
//        },
        computed: {
            canAdd(){
                return this.$store.getters.hasPermission("BANK_ADD");
            },
            canEdit(){
                return this.$store.getters.hasPermission("BANK_EDIT");
            },
            canDel(){
                return this.$store.getters.hasPermission("BANK_DEL");
            }

        },
        activated(){
            //this.reload();
            this.getSearchList();
        },
        watch:{
            '$route':'getSearchList'
        },

    }

</script>

<style lang="scss" scoped>
    .menu{
        .right{
            float: right;
        }
    }
    .el-tag + .el-tag {
        margin-left: 5px;
    }
    .xinz button{background:#4B78FF;border:none;margin-bottom:1rem;}
    .xinz button:hover{background:#4B78FF;color:#fff;}
</style>




// WEBPACK FOOTER //
// src/views/Searcha.vue